import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-nb-radio',
  template: `
<div class="row">
<div class="col-4 d-flex align-items-center">
    <label for="input" class="form-label
    ">{{ to.label }}</label>
</div>
  <div class="col-8 mb-2">
    <nb-radio-group fullWidth [formControl]="formControl" [status]="(formControl.errors)? 'danger' : 'basic'">
      <nb-radio fullWidth *ngFor="let option of to.options" [value]="option.value">{{ option.label }}</nb-radio>
    </nb-radio-group>
    <p class="text-danger" *ngIf="formControl.errors?.required">{{to.label}} is required.</p>
    </div>
</div>
  `,
})
export class FormlyFieldNbRadio extends FieldType {}
